import React from 'react';
import TaxonomyFilter from '../../components/TaxonomyFilter';
import store from '../../services/ReduxStore';
import qs from 'qs';
import { map } from 'lodash';
import tbkApi from '../../services/tbkApi';
import ElasticMapper from '../../services/ElasticMapper';
import {t} from 'i18next';
import classNames from 'classnames';
import Loader from 'react-loader-spinner';
import SidebarActions from '../../components/SidebarActions';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

class Products extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			search: this.getStateFromSearch(),
			products: null,
			showAllTerms: {},
			filterModalOpen: false,
		};
		this.handleOutsideLink = this.handleOutsideLink.bind(this);
	}

	componentDidMount() {
		this.fetchProducts();
		document.addEventListener('click',this.handleOutsideLink);
	}

	componentWillUnmount() {
		document.removeEventListener('click',this.handleOutsideLink);
	}

	/**
	 * This is to handle the case of the user clicking on a link to something within the product app but actually
	 * lives outside of the app.  For example, the footer links or the top "Search By" menu.  The purpose of this is
	 * to determine if it's a link to a state within the app and if it is, then update the search within the state,
	 * fetch products, and scroll to the app.
	 *
	 * @param e
	 */
	handleOutsideLink(e) {
		if ( e.defaultPrevented ) {
			return;
		}
		const anchor = ( 'A' === e.target.tagName ) ? e.target : e.target.closest('a');
		if ( anchor && ! anchor.closest('#app-root') && anchor.href ) {
			const matches = anchor.href.match(/^(.*)(#.*)$/);
			// If it's a deep link and to the same page as the app.
			if ( matches && matches[1] === window.location.href.replace(/#.*$/,'') ) {
				e.preventDefault();
				this.setState({
					search: {
						...this.state.search,
						...this.getStateFromSearch( matches[2] ),
					}
				},() => {
					this.fetchProducts();
					// The getBoundingClientRect is the browser friendly way of determining the offset of the element wrt the body
					window.scrollTo( 0, document.getElementById('app-root').getBoundingClientRect().top - document.body.getBoundingClientRect().top );
				});
			}
		}
	}

	fetchProducts() {
		this.setState({loading:true});
		const timeout = setTimeout( () => {
			this.setState({
				loadingLongTime: true
			})
		}, 3000 );
		tbkApi.getProducts({
			filter: this.state.search.filter.join(','),
			page: this.state.search.page,
			offset: ( this.state.search.page === 0 ) ? 0 : ( this.state.products ? this.state.products.length : 0 ),
			quickShip: this.state.search.quickShip ? 1 : 0,
			order: this.state.search.order
		}).then( result => {
			const mappedProducts = ElasticMapper( result );
			clearTimeout( timeout );
			this.setState({
				total: result.total,
				loading: false,
				loadingLongTime: false,
				products: ( this.state.search.page && ( 'all' !== this.state.search.page ) ) ? [ ...(this.state.products || []), ...mappedProducts ] : mappedProducts,
			});
		});
	}

	getStateFromSearch( hash ) {
		const search = qs.parse( ( hash || this.props.location.hash ).replace(/^#!/,''), { ignoreQueryPrefix: true } )
		return {
			expanded: search.expanded ? search.expanded.split(',') : [],
			filter: ( search.filter ? search.filter.split(',') : [] ).map( term_id => parseInt( term_id, 10 ) ),
			page: search.page ? ( 'all' === search.page ? 'all' : parseInt( search.page, 10 ) ) : 0,
			quickShip: search.quickShip ? 1 : 0,
			order: search.order ? search.order : null
		}
	}

	getSearchFromState() {
		let search = {};
		['expanded','filter'].forEach( which => {
			if ( this.state.search[ which ] && this.state.search[ which ].length ) {
				search[ which ] = this.state.search[ which ].join(',');
			}
		});
		['page','quickShip','order'].forEach( which => {
			if ( this.state.search[ which ] ) {
				search[ which ] = this.state.search[ which ];
			}
		});
		return Object.keys( search ).length ? '#!' + qs.stringify( search ) : '';
	}

	toggleExpanded( taxonomy ) {
		let expanded = [ ...this.state.search.expanded ];
		const position = expanded.indexOf( taxonomy );
		if ( -1 === position ) {
			expanded.push( taxonomy );
		} else {
			expanded.splice( position, 1, );
		}
		this.setState({
			search: {
				...this.state.search,
				expanded
			}
		});
	}

	toggleQuickShip() {
		this.setState({
			search: {
				...this.state.search,
				quickShip: this.state.search.quickShip ? 0 : 1,
				page: 0,
			}
		},() => {
			this.fetchProducts();
		});
	}

	toggleAllTerms( taxonomy, state ) {
		this.setState({
			showAllTerms: {
				...this.state.showAllTerms,
				[taxonomy]: state
			}
		});
	}

	onChangeOrder( e ) {
		this.setState({
			search: {
				...this.state.search,
				order: e.target.value,
				page: 0,
			}
		},() => {
			this.fetchProducts();
		});
	}

	onChangeFilter( e ) {
		const term_id = parseInt( e.target.value, 10 );
		const isChecked = e.target.checked;
		let filter = [ ...this.state.search.filter ];
		const position = filter.indexOf( term_id );
		if ( isChecked && position === -1 ) {
			filter.push( term_id );
		} else if ( ! isChecked && position !== -1 ) {
			filter.splice( position, 1 );
		}
		this.setState({
			search: {
				...this.state.search,
				filter,
				page: 0
			}
		},() => {
			this.fetchProducts();
		});
	}

	loadMore() {
		this.setState({
			search: {
				...this.state.search,
				page: this.state.search.page + 1
			}
		}, () => {
			this.fetchProducts()
		});
	}

	loadAll() {
		this.setState({
			search: {
				...this.state.search,
				page: 'all'
			}
		}, () => {
			this.fetchProducts()
		});
	}

	resetFilters() {
		this.setState({
			search: {
				...this.state.search,
				filter: [],
				page: 0,

			}
		}, () => {
			this.fetchProducts()
		});
	}

	componentDidUpdate() {
		const serializedState = this.getSearchFromState();
		if ( serializedState !== this.props.location.hash ) {
			this.props.history.replace( this.props.location.pathname + serializedState );
		}
	}

	render() {
		const sortOptions = {
			//popular: t('Most Popular'),
            alpha_asc: t('Alphabetic (A to Z)'),
            alpha_desc: t('Alphabetic (Z to A)'),
			date_desc: t('Most Recent'),
			// price_asc: t('Price (Low to High)'),
			// price_desc: t('Price (High to Low)'),

		};

		const assets = store.getState().app.assets;

        for(var strTaxonomyKey in assets.terms){
            //console.log(strTaxonomyKey); //or data[key] if you want the values
            var sortedTerms = [];
            for(var strSortedIndex in assets.term_ordermap) {
                for (var strTermKey in assets.terms[strTaxonomyKey]) {

                    if (assets.terms[strTaxonomyKey][strTermKey].term_id === assets.term_ordermap[strSortedIndex].term_id) {
                        sortedTerms.push(assets.terms[strTaxonomyKey][strTermKey]);
                    }
                }
            }
            console.log(sortedTerms);
            assets.terms[strTaxonomyKey] = sortedTerms;
        }
        

		return <React.Fragment>
			<div className="product-sidebar dd">
				{this.state.search.filter.length ? <button className="product-sidebar__clear-all" type="button" onClick={e => this.resetFilters()}>{t('Clear All')}</button> : null}
				{assets.taxonomies.map( taxonomy =>
					<TaxonomyFilter
						key={taxonomy.taxonomy}
						taxonomy={taxonomy.taxonomy}
						label={taxonomy.label}
						terms={assets.terms[ taxonomy.key ]}
						expanded={this.state.search.expanded.indexOf( taxonomy.key ) !== -1}
						checked={this.state.search.filter}
						maxTermsOnFirstLevel={12}
						toggleAllTerms={state => this.toggleAllTerms( taxonomy.key, state )}
						showAllTerms={this.state.showAllTerms[ taxonomy.key ]}
						onToggle={e => this.toggleExpanded( taxonomy.key )}
						onChange={e => this.onChangeFilter( e )}
					/>)
				}

				<SidebarActions actions={store.getState().app.assets.sidebar_actions}/>
			</div>

			<div id="product-sidebar-modal" className={`modal ${(this.state.filterModalOpen ? 'in' : 'not-in' )}`} role="dialog">
				<div className="product-sidebar" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="apply btn btn-primary" onClick={e=> {
								this.setState( {filterModalOpen:false} );
								document.body.classList.toggle('modal-open');
								} }>
								{t('Apply')}
							</button>
							{this.state.search.filter.length ? <button className="product-sidebar__clear-all" type="button" onClick={e => this.resetFilters()}>{t('Clear All')}</button> : null}
							<button type="button" className="btn-close" title={t('Close')} onClick={e=> {
								this.setState( {filterModalOpen:false} );
								document.body.classList.toggle('modal-open');
								} }>
							   <i className="icon icon-close"></i>
							</button>
						</div>

						<div className="modal-body">
							<div className="product-main__header-filters">
								{( assets.has_quickship || this.state.search.quickShip ) ? <span className="quick-shipping-toggle" onClick={e => this.toggleQuickShip()}>
									<label>{t('Quick Shipping')}</label>
									<span className={classNames({'toggle':true,'active':this.state.search.quickShip})}>{this.state.search.quickShip ? 'on' : 'off'}</span>
								</span> : null}
							</div>

							{assets.taxonomies.map( taxonomy =>
								<TaxonomyFilter
									key={taxonomy.taxonomy}
									taxonomy={taxonomy.taxonomy}
									label={taxonomy.label}
									terms={assets.terms[ taxonomy.key ]}
									expanded={this.state.search.expanded.indexOf( taxonomy.key ) !== -1}
									checked={this.state.search.filter}
									maxTermsOnFirstLevel={12}
									toggleAllTerms={state => this.toggleAllTerms( taxonomy.key, state )}
									showAllTerms={this.state.showAllTerms[ taxonomy.key ]}
									onToggle={e => this.toggleExpanded( taxonomy.key )}
									onChange={e => this.onChangeFilter( e )}
								/>
							)}
						</div>
					</div>
				</div>
			</div>

			<div className="product-main">
				<div className="product-main__header">
					 <button className="product-sidebar-modal-trigger btn btn-primary" onClick={e=> {
							this.setState( {filterModalOpen:true} );
							document.body.classList.toggle('modal-open'); } } >
						<i className="icon icon-filters-icon"></i>
						{t('Filters')}
					</button>
					<div className="product-main__header-results">
						{ this.state.products ? <span className="count"><strong>{this.state.total}</strong> {t( this.state.total === 1 ? 'result' : 'results')}</span> : null}
					</div>
					<div className="product-main__header-filters">
						{( assets.has_quickship || this.state.search.quickShip ) ? <span className="quick-shipping-toggle" onClick={e => this.toggleQuickShip()}>
							<label>{t('Quick Shipping')}</label>
							<span className={classNames({'toggle':true,'active':this.state.search.quickShip})}>{this.state.search.quickShip ? 'on' : 'off'}</span>
						</span> : null}
						<span className="sort-control">
							<label htmlFor="sort-select">{t('Sort By')}</label>
							<div className="select-wrapper">
								<select id="sort-select" onChange={e => this.onChangeOrder(e)} defaultValue={this.state.search.order}>
									{map( sortOptions, ( label, value ) => <option key={value} value={value}>{label}</option>)}
								</select>
							</div>
						</span>
					</div>
				</div>
				<div className="product-main__body">
					{ ( this.state.products && ! this.state.total ) ? <p className="no-results">{t('No results found.  Please adjust your filters')}</p> : null }
					{ ( this.state.products || [] ).map( product => {
						return <a href={product.permalink} key={product.ID} className="single-product">
							<img src={product.image} alt={product.short_pattern_name + ' - ' + product.sku_acf}/>
							<div className="product-single__inner">
								<h6>{product.short_pattern_name}</h6>
								{ product.quick_ship !== "0" && product.quick_ship !== 0 && (
                                  <div className="quick-ship">{t('Quick Ship')}</div>
                                )}
							</div>
							{ product.price ? <span className="price"><strong>${product.price}</strong>/{t('roll')}</span> : null}
						</a>
					})}
					{ ( ! this.state.loading && ( this.state.products || [] ).length < this.state.total ) ?
						<div className="product-load__buttons">
							<button className="product-load-btn btn btn-info" type="button" onClick={e => this.loadMore()}>{t('Show More')}</button>
							<button className="product-load-btn btn btn-info" type="button" onClick={e => this.loadAll()}>{t('Show All')}</button>
						</div>
					: null}
					{this.state.loading &&
						<div className="product-load__loader">
							<Loader
								type="Oval"
								color="#0D3862"
								height={80}
								width={80}
							/>
							{this.state.loadingLongTime &&
								<p>{t('Please standby, loading lots of products can take a little while.')}</p>
							}
						</div>
					}
				</div>
			</div>
		</React.Fragment>;
	}
}

export default Products;


// WEBPACK FOOTER //
// ./src/containers/Products/Products.js